export const CALENDAR_ITEM_CORNER_RARIUS = 5
export const outlookPrefix = 'Outlook'
export const icloudPrefix = 'icloud'

export const prefixGoogleEventsGroup = 'GOOGLE_EVENTS'

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}

export const APP_LINK = 'https://groupcal.page.link'
